import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingImageToJpegConfig } from '@/data/landingConfig/landingImageToJpegConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageToJpeg } from './schemaObject';

interface Props {}
const ImageToJpegConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageToJpeg} />
			<LandingTemplate
				data={landingImageToJpegConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default ImageToJpegConverter;
